import { EmptyContainer, EmptyText, EmptyTitle } from './styles';

export default function AppHomeEmptyValue() {
  return (
    <EmptyContainer>
      <img src="/images/company 1.png" alt="empty" />

      <EmptyTitle>Ops..</EmptyTitle>

      <EmptyText>
        Ainda não estamos operando na sua cidade ou certifique que o nome da
        cidade está correto.
      </EmptyText>
    </EmptyContainer>
  );
}
